import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
import { FileUploadModalBody } from '@rd-web-markets/shared/dist/util';
const FurtherRequirementDocumentUploadModal = _ref => {
  let {
    show,
    onHide,
    uploadDocuments
  } = _ref;
  const {
    t
  } = useTranslation();
  const [uploadAllowed, setUploadAllowed] = useState(false);
  const [fileNotSelected, setFileNotSelected] = useState(false);
  useEffect(() => {
    if (!show) {
      setUploadAllowed(false);
    }
  }, [show]);

  /** useFileUpload passes FormData with `document`; usePostFormData expects { formDataJson: plainObject } (see service_methods.usePostFormData). */
  const upload = useCallback(formData => {
    const document = formData.get('document');
    uploadDocuments({
      formDataJson: {
        document,
        'further_requirement_document[further_requirement_field]': 'fr_1_1'
      }
    });
  }, [uploadDocuments]);
  const renderBody = /*#__PURE__*/React.createElement(FileUploadModalBody, {
    uploadAllowed: uploadAllowed,
    upload: upload,
    setFileNotSelected: setFileNotSelected,
    customFormName: "document"
  });
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: t('upload'),
    show: show,
    renderBody: () => renderBody,
    onHide: onHide,
    onSubmit: () => setUploadAllowed(true),
    submitText: t('upload'),
    disabled: fileNotSelected
  });
};
export default FurtherRequirementDocumentUploadModal;